import React from 'react'

function NotificationIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      {...props}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#b5f292" />
          <stop offset="0.962" stopColor="#a6de85" />
          <stop offset="1" stopColor="#ace68a" />
        </linearGradient>
      </defs>
      <g id="Groupe_3467" data-name="Groupe 3467" transform="translate(-491.43 -1137.43)">
        <circle
          id="Ellipse_3010"
          data-name="Ellipse 3010"
          cx="9"
          cy="9"
          r="9"
          transform="translate(491.43 1137.43)"
          fill="#ace68a"
        />
        <path
          id="Icon_awesome-bell"
          data-name="Icon awesome-bell"
          d="M3.624,8.284A1.035,1.035,0,0,0,4.659,7.248H2.589A1.035,1.035,0,0,0,3.624,8.284ZM7.109,5.862a3.01,3.01,0,0,1-.9-2.5A2.555,2.555,0,0,0,4.142.855V.518a.517.517,0,1,0-1.035,0V.855a2.555,2.555,0,0,0-2.07,2.51,3.01,3.01,0,0,1-.9,2.5A.506.506,0,0,0,0,6.213a.518.518,0,0,0,.519.518h6.21a.518.518,0,0,0,.519-.518.505.505,0,0,0-.139-.351Z"
          transform="translate(496.879 1142.288)"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export default NotificationIcon
